.container {
  position: relative;
}

.item {
  padding-right: calc(
    var(--dixa-size-spacer-500) + var(--dixa-size-spacer-100)
  );
}

.pinButton {
  position: absolute;
  right: 0;
  top: 2px;
  opacity: 1;
  transition:
    opacity 150ms ease-in,
    transform 200ms;

  &:hover {
    svg {
      transform: scale(1.2);
    }
  }

  svg {
    transition: transform 200ms;
  }
}
